import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { isMobileBrowser, isNativeDevice } from '@utils';

import { IconCaretDown } from '../icons';
import { TranslationKeys } from '../types';
import { useDropdownService } from './dropdown-menu.service';
import { DropdownMenuProps } from './dropdown-menu.type';

export const DropdownMenu: React.FC<DropdownMenuProps> = ({
  labelKey,
  options,
  selectedOption,
  setSelectedOption,
  formId,
  className,
  variant = 'primary',
  Icon,
}) => {
  const { t } = useTranslation();
  const isMobilePlatform = isNativeDevice || isMobileBrowser;

  const {
    containerClasses,
    arrowIconClasses,
    selectedLabel,
    isOpen,
    toggleDropdown,
    handleOptionClick,
    handleNativeChange,
    dropdownOptionClasses,
  } = useDropdownService({
    setSelectedOption,
    selectedOption,
    options,
    className,
    labelKey,
    variant,
  });
  const classes = classNames('dropdown-box', className, {
    [`dropdown-box-${variant}`]: variant,
  });

  const optionsClasses = classNames('dropdown-options', className, {
    [`dropdown-options-${variant}`]: variant,
  });

  return (
    <div className={containerClasses}>
      <div
        id={formId}
        className={classes}
        onClick={isMobilePlatform ? undefined : toggleDropdown}
      >
        {Icon !== undefined && <Icon className="scale-75" />}
        <span className={selectedLabel.styleClass}>
          {t(selectedLabel.label as TranslationKeys)}
        </span>
        <IconCaretDown className={arrowIconClasses} />

        {isMobilePlatform && (
          <select
            id={`${formId}-native-select`}
            value={selectedOption}
            onChange={handleNativeChange}
            className="native-select-hidden"
          >
            {options.map(option => (
              <option key={option.key} value={option.key}>
                {t(option.labelKey as TranslationKeys)} {option.label}
              </option>
            ))}
          </select>
        )}
      </div>

      {/* Custom dropdown for non-mobile */}
      {!isMobilePlatform && isOpen && (
        <div className={optionsClasses}>
          {options.map(option => (
            <button
              key={option.key}
              className={dropdownOptionClasses(option.key as string)}
              onClick={() => handleOptionClick(option.key as string)}
            >
              {t(option.labelKey as TranslationKeys)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
